import { Link } from 'react-router-dom';

interface SectionHeaderProps {
  title: string;
  subtitle?: string;
  moreTo?: string;
  moreText?: string;
  accentIcon?: string;
}

export default function SectionHeader({ title, subtitle, moreTo, moreText = '查看全部', accentIcon }: SectionHeaderProps) {
  return (
    <div className="flex items-end justify-between gap-4 mb-6">
      <div className="flex items-center gap-3">
        {accentIcon && (
          <span className="w-10 h-10 flex items-center justify-center rounded-lg bg-primary-50 text-primary-600 text-xl">
            <i className={accentIcon}></i>
          </span>
        )}
        <div>
          <h2 className="text-xl md:text-2xl font-bold text-foreground-950">{title}</h2>
          {subtitle && <p className="text-sm text-foreground-500 mt-1">{subtitle}</p>}
        </div>
      </div>
      {moreTo && (
        <Link
          to={moreTo}
          className="shrink-0 inline-flex items-center gap-1 text-sm text-primary-600 hover:text-primary-700 whitespace-nowrap cursor-pointer"
        >
          {moreText}
          <i className="ri-arrow-right-s-line"></i>
        </Link>
      )}
    </div>
  );
}